"use client"

import { useReportWebVitals } from "next/web-vitals"

/**
 * Core Web Vitals collection (US-039, S-P4-2). Reports every metric to
 * `POST /api/observability/web-vitals`, which runs server-side and tags it by
 * tenant (read from the request, not trusted from this payload) before
 * recording it as an OpenTelemetry metric (`lib/web-vitals-metrics.ts`).
 *
 * Mounted once in the root layout (`app/[locale]/layout.tsx`), outside the
 * tenant-specific `<TenantShell>` — it needs no tenant data itself, the
 * server-side sink resolves that from the request.
 */
export function WebVitals() {
  useReportWebVitals((metric) => {
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      // No query string (could carry an address/promo code) — `/api/*` routes
      // are excluded from proxy.ts's matcher, so the sink has no `x-pathname`
      // of its own to fall back on.
      path: typeof location !== "undefined" ? location.pathname : undefined,
    })

    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(
        "/api/observability/web-vitals",
        new Blob([body], { type: "application/json" })
      )
      return
    }

    void fetch("/api/observability/web-vitals", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => undefined)
  })

  return null
}
